import { Component, input, model } from '@angular/core';

import { ButtonComponent } from '@agilox/ui';
import { Mode } from '@agilox/common';

@Component({
	selector: 'binary-toggler',
	imports: [ButtonComponent],
	templateUrl: './binary-toggler.component.html',
})
export class BinaryTogglerComponent {
	rightSide = input<Mode>();
	leftSide = input<Mode>();
	disableIcon = input<boolean>(false);
	currentMode = model<boolean>(false);

	toggle(side: boolean) {
		if (side !== this.currentMode()) {
			this.currentMode.set(side);
		}
	}
}
